import React from 'react';
import { Cn, Cny, De, En, Es, Eur, Hu, It, Ja, Ko, Ru, Rub, Usd } from "../../../../icons";
export var langs = [{
  choose: 'Готово',
  titleChoose: 'Выберите язык',
  titleCurrency: 'Выберите валюту',
  locale: 'ru',
  title: 'Русский',
  flag: /*#__PURE__*/React.createElement(Ru, {
    size: "md"
  })
}, {
  choose: '完成了',
  titleChoose: '选择语言',
  titleCurrency: '选择货币',
  locale: 'zh',
  title: '中文',
  flag: /*#__PURE__*/React.createElement(Cn, {
    size: "md"
  })
}, {
  choose: 'Done',
  titleChoose: 'Choose language',
  titleCurrency: 'Choose currency',
  locale: 'en',
  title: 'English',
  flag: /*#__PURE__*/React.createElement(En, {
    size: "md"
  })
}, {
  choose: 'Fatto',
  titleChoose: 'Scegli la lingua',
  titleCurrency: 'Scegli la valuta',
  locale: 'it',
  title: 'Italiano',
  flag: /*#__PURE__*/React.createElement(It, {
    size: "md"
  })
}, {
  choose: 'Getan',
  titleChoose: 'Sprache wählen',
  titleCurrency: 'Währung wählen',
  locale: 'de',
  title: 'Deutsch',
  flag: /*#__PURE__*/React.createElement(De, {
    size: "md"
  })
}, {
  choose: 'Hecho',
  titleChoose: 'idioma',
  titleCurrency: 'moneda',
  locale: 'es',
  title: 'Español',
  flag: /*#__PURE__*/React.createElement(Es, {
    size: "md"
  })
}, {
  choose: 'Done',
  titleChoose: 'Choose language',
  titleCurrency: 'Choose currency',
  locale: 'ja',
  title: '日本語',
  flag: /*#__PURE__*/React.createElement(Ja, {
    size: "md"
  })
}, {
  choose: 'Done',
  titleChoose: 'Choose language',
  titleCurrency: 'Choose currency',
  locale: 'ko',
  title: '한국어',
  flag: /*#__PURE__*/React.createElement(Ko, {
    size: "md"
  })
}, {
  choose: 'Done',
  titleChoose: 'Choose language',
  titleCurrency: 'Choose currency',
  locale: 'hu',
  title: 'Magyar',
  flag: /*#__PURE__*/React.createElement(Hu, {
    size: "md"
  })
}];
export var currens = [{
  label: {
    ru: 'Рубль',
    en: 'Ruble',
    zh: '卢布',
    it: 'Rublo',
    de: 'Rubel',
    es: 'Rublo'
  },
  icon: /*#__PURE__*/React.createElement(Rub, {
    size: "md"
  }),
  code: 'RUB'
}, {
  label: {
    ru: 'Евро',
    en: 'Euro',
    zh: '欧元',
    it: 'Euro',
    de: 'Euro',
    es: 'Euro'
  },
  icon: /*#__PURE__*/React.createElement(Eur, {
    size: "md"
  }),
  code: 'EUR'
}, {
  label: {
    ru: 'Доллар',
    en: 'Dollar',
    zh: '美元',
    it: 'Dollaro',
    de: 'Dollar',
    es: 'Dólar'
  },
  icon: /*#__PURE__*/React.createElement(Usd, {
    size: "md"
  }),
  code: 'USD'
}, {
  label: {
    ru: 'Юань',
    en: 'Yuan',
    zh: '元',
    it: 'Yuan',
    de: 'Yuan',
    es: 'Yuan'
  },
  icon: /*#__PURE__*/React.createElement(Cny, {
    size: "md"
  }),
  code: 'CNY'
}];
export var languages = langs.map(function (item) {
  return item.locale;
});
export var currencies = currens.map(function (item) {
  return item.code;
});
var currensLabel = currens.map(function (item) {
  return item.label;
});